{
    "Profile_Summary.attention": "FR: Attention",
    "Profile_Summary.warning": "FR: Warning",
    "Profile_Summary.error": "FR: Error",

    "Profile_Summary.status.quoteAccepted": "FR: Quote Accepted",
    "Profile_Summary.status.quoteIssued": "FR: Quote Issued",
    "Profile_Summary.status.bindRequested": "FR: Bind Requested",
    "Profile_Summary.status.bound": "FR: Bound",
    "Profile_Summary.status.issued": "FR: Issued",
    "Profile_Summary.status.quoted": "FR: Quoted"
}
